import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import './img-view.css'

import { getStaticPath } from '@/util/request'

const Agent = {

}

export default {
  props:{
    src: {
      type: String,
      default: ''
    },
    public: {
      type: Boolean,
      default: false
    },
  },

  data(){
    return {
      viewer:null,
      url:null,
      visible:false,
    }
  },
  mounted(){

  },
  beforeDestroy(){
    if( this.viewer ){
      this.viewer.destroy()
    }
  },
  created() {
    if (this.src) {
      this.load(this.src)
    }
  },

  methods: {
    handleClick(){
      let viewer = this.viewer
      if( !viewer ){
        //console.log(  this.$refs['here'] )
        viewer  = new Viewer(this.$refs['imgwrap'], {
          inline:true,
          backdrop:false,
          title:false,
          fullscreen:false,
          // className:'sl-img-view',
          // container:this.$refs['here'],
          viewed() {
            viewer.zoomTo(1);
          },
        });

        this.viewer = viewer
        viewer.show()
      }
      this.visible = true
    },
    load(val) {
      if (val) {
        this.loading = true

        if (this.public) {
          this.loading = false
          this.url = getStaticPath(val)
        } else {
          this.$request.image(val, this.method).then(resp => {
            let { data } = resp
            this.loading = false

            if (this.type == 'img') {
              this.loadByObjectURL(data)
            }
          })
        }
      }
    },
    loadByObjectURL(data) {
      this.url = window.URL.createObjectURL(data)
    },

  },
  render(){
    return <div on-click={this.handleClick}>
      <img src={this.url} />
      {
        this.loading ? <Spin /> : null
      }
      {
        this.$scopedSlots.default ? this.$scopedSlots.default() : null
      }
      <Modal title="预览" draggable={true} v-model={this.visible} footer-hide={true} class="sl-modal n-padding paddingless">
        <div ref="imgwrap" style="width: 100%;height:60vh;position:relative;background:#000;">
          <img style="display:none;" src={this.url} />
        </div>
      </Modal>
    </div>
  }
}